<script setup lang="ts">
    import { useRecommendationPortal } from "@/stores/portal";

    import Button from "@/components/tellscale/primitives/Button.vue";

    const { t } = useI18n();

    const portal = useRecommendationPortal();

    const openExternal = (url?: string | null) => {
        if(!url) return;

        try {
            const href = String(url);
            window.open(href, "_blank");
        } catch (e) {
            console.log("Error opening external link: ", e)
        }
    };

    const redirectToImprint = async () => {
        if(!portal.value) return;

        openExternal(portal.value.settings?.impressum_url);
    };

    const redirectToTermsOfService = async () => {
        if(!portal.value) return;

        if (portal.value.settings?.agb_enabled) {
            openExternal(portal.value.settings?.agb_url);
        }
    };

    const redirectToPrivacyPolicy = async () => {
        if(!portal.value) return;

        openExternal(portal.value.settings?.privacy_url);
    };
</script>

<template>
    <div v-if="portal.isLoaded" class="flex w-90 justify-between flex-wrap">
        <Button @click="redirectToImprint" class="min-w-fit text-foreground" variant="link">
            {{ t('legal.imprint') }}
        </Button>
        
        <Button v-if="portal.value?.settings?.agb_enabled === true" @click="redirectToTermsOfService" class="min-w-fit text-foreground" variant="link">
            {{ t('legal.termsOfService') }}
        </Button>
        
        <Button @click="redirectToPrivacyPolicy" class="min-w-fit text-foreground" variant="link">
            {{ t('legal.privacyPolicy') }}
        </Button>
    </div>
</template>

<style scoped lang="scss">

</style>